// src/utils/encryptionService.ts
import CryptoJS from "crypto-js";

export class DecryptionService {

  private static readonly encryptionKey = "eKyhpIoXY2YtCK41";
  private static readonly ivKey = "7v12oT7w9sNkDLos";

  private static getKey() {
    return CryptoJS.enc.Utf8.parse(this.encryptionKey);
  }

  private static getIV() {
    return CryptoJS.enc.Utf8.parse(this.ivKey);
  }

  static decrypt(encryptedText: string): string {
    try {
      const key = this.getKey();
      const iv = this.getIV();

      const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      const result = decrypted.toString(CryptoJS.enc.Utf8);

      if (!result) {
        throw new Error('Decryption failed: empty result');
      }

      return result;

    } catch (error) {
      console.error('AES Decryption Error:', error);
      return encryptedText; // safe fallback
    }
  }
}